module.exports = __webpack_public_path__ + "static/assets/de2d975f826e11936100c21fed2dc24a.png";